import { ComponentTable } from '../component.constants';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import { Settings } from 'approot/shared/richtext/richtext.constants';
import type { SuggestedAnswerFragment } from '../suggested-answers/suggested-answers.graphql.generated';
import { JSONObject } from 'global/graphql/scalars.type';
import type { Pluck } from 'lib/gql/pluck';

export type TableProperties = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesTableComponent' }
  >,
  'properties'
>;
export type Table = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesTableComponent' }
  >,
  'properties.table'
>;
export type TableRow = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesTableComponent' }
  >,
  'properties.table.rows'
>;
export type TableCell = Pluck<
  Extract<
    Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.components'>,
    { __typename: 'ActivitiesTableComponent' }
  >,
  'properties.table.rows.cells'
>;

export type Row = {
  cells: TableCell[];
};

export type ViewProps = Omit<ComponentTable, '__typename'>;
export type EditProps = ViewProps;
export type SettingsProps = ViewProps & { onCloseChildDrawer?: () => void };

export const TABLE_TYPENAME = 'ActivitiesTableComponent';

export const RICHTEXT_SETTINGS: Settings = {
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export const MAX_TABLE_COLUMNS = 6;
export const MAX_TABLE_ROWS = 10;
export const NEW_TABLE_COLUMN_WIDTH = 100;
export const MIN_TABLE_COLUMN_WIDTH = 50;

export type TableDataCell = {
  isAnswer: boolean;
  suggestedAnswer?: Pluck<SuggestedAnswerFragment, 'suggestedAnswers'>;
  value: JSONObject;
};

export type TableDataRow = {
  cells: TableDataCell[];
};

export type TableData = {
  showColumnHeaders: boolean;
  showRowHeaders: boolean;
  columnWidths: number[];
  rows: TableDataRow[];
};
